import React from 'react';
import CloseIconComponent from '../../CloseIcon/components/CloseIcon';
import css from './CloseIcon.css';
var CloseIcon = function (onClick) {
    return React.createElement(CloseIconComponent, { className: css.close, onClick: onClick, isGray: true });
};
export default CloseIcon;
